import { Spinner } from '@iaa-di/spinner'
import { useIntl } from 'react-intl'

export function DialogLoadingFallback() {
  const intl = useIntl()

  return (
    <div className="fixed inset-0 bg-white opacity-60 flex items-center justify-center z-50">
      <div
        className="pt-16 absolute left-[47%] z-[300]"
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <Spinner />
        <span className="sr-only">
          {intl.formatMessage({ id: 'components.dialogManager.loading' })}
        </span>
      </div>
    </div>
  )
}
